const blogcategory = {
    getlist: 'blogcategory/getlist',
    add: 'blogcategory/add',
    update: 'blogcategory/update',
    remove: 'blogcategory/remove',
    get: 'blogcategory/get',
    getall: 'blogcategory/getall',
    clearcache: 'blogcategory/clear-cache',
}
export default blogcategory
